import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TenantDto } from '@picflow/types';
import { AnimatedLoaderComponent } from '../../../shared-extra/components/animated-loader/animated-loader.component';
import { ProfileUrlPipe } from '../../../shared-extra/pipes/profile-url.pipe';

@Component({
  selector: 'app-tenant-icon-loader',
  templateUrl: './tenant-icon-loader.component.html',
  styleUrls: ['./tenant-icon-loader.component.scss'],
  standalone: true,
  imports: [NgIf, AnimatedLoaderComponent, ProfileUrlPipe],
})
export class TenantIconLoaderComponent {
  @Input() tenant: TenantDto;
}
